<template>
  <el-container class="layout-container">
    <div
      v-show="mobileMenuOpen"
      class="mobile-overlay"
      @click="closeMobileMenu"
    ></div>
    <el-aside
      :width="sidebarWidth"
      class="sidebar"
      :class="{ 'is-open': mobileMenuOpen }"
    >
      <div v-if="isMobile" class="sidebar-mobile-head">
        <span>导航菜单</span>
        <span class="sidebar-mobile-close" role="button" aria-label="关闭菜单" @click="closeMobileMenu">
          <i class="el-icon-close"></i>
        </span>
      </div>
      <a class="logo" :href="siteLinks.www + '/'" target="_blank" rel="noopener noreferrer">
        <span v-if="!isCollapse || isMobile">码智作二维码</span>
        <span v-else>码</span>
      </a>
      <el-menu
        :default-active="activeMenu"
        :collapse="menuCollapsed"
        :unique-opened="true"
        router
        @select="onMenuSelect"
        background-color="#ffffff"
        text-color="#333333"
        active-text-color="#409EFF"
      >
        <el-menu-item index="/home">
          <i class="el-icon-s-home"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        
        <el-submenu index="qrcode">
          <template slot="title">
            <i class="el-icon-s-grid"></i>
            <span>二维码管理</span>
          </template>
          <el-menu-item index="/qrcode/generate">生成二维码</el-menu-item>
          <el-menu-item index="/qrcode/list">二维码列表</el-menu-item>
          <el-menu-item index="/qrcode/image-space">图片空间</el-menu-item>
          <el-menu-item index="/qrcode/audio-space">音频空间</el-menu-item>
          <el-menu-item index="/qrcode/document-space">文档空间</el-menu-item>
        </el-submenu>
        
        <el-submenu index="member">
          <template slot="title">
            <i class="el-icon-s-custom"></i>
            <span>会员信息</span>
          </template>
          <el-menu-item index="/member/upgrade">升级会员</el-menu-item>
          <el-menu-item
            v-if="canUpgradeDiff"
            index="/member/upgrade-diff"
          >补差价升级</el-menu-item>
          <el-menu-item index="/member/purchased">已购项目</el-menu-item>
          <el-menu-item index="/member/invoice">发票记录</el-menu-item>
          <el-menu-item index="/member/usage">会员及空间用量</el-menu-item>
        </el-submenu>
        
        <el-submenu index="tools">
          <template slot="title">
            <i class="el-icon-s-tools"></i>
            <span>在线工具</span>
          </template>
          <el-menu-item index="/tools/image-compress">批量图片压缩</el-menu-item>
          <el-menu-item index="/tools/image-convert">图片格式转换</el-menu-item>
          <el-menu-item index="/tools/image-watermark">图片加水印</el-menu-item>
          <el-menu-item index="/tools/image-crop">图片裁剪</el-menu-item>
          <el-menu-item index="/tools/pdf-toolbox">PDF工具箱</el-menu-item>
          <el-menu-item index="/tools/qrcode-decode">二维码解码</el-menu-item>
          <el-menu-item index="/tools/dpi-modify">图片DPI修改</el-menu-item>
          <el-menu-item index="/tools/exif-editor">EXIF编辑</el-menu-item>
          <el-menu-item index="/tools/image-overlay">图片叠加</el-menu-item>
          <el-menu-item index="/tools/video-convert">视频转码</el-menu-item>
        </el-submenu>
        
        <el-submenu index="user">
          <template slot="title">
            <i class="el-icon-user"></i>
            <span>用户资料</span>
          </template>
          <el-menu-item index="/user/settings">用户设置</el-menu-item>
          <el-menu-item index="/user/wechat">绑定微信</el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>
    
    <el-container class="layout-body">
      <el-header class="header">
        <div class="header-left">
          <i
            class="el-icon-s-fold mobile-menu-btn"
            role="button"
            aria-label="打开菜单"
            @click.stop="toggleMobileMenu"
          ></i>
          <span v-if="isMobile && currentRoute" class="mobile-page-title">{{ currentRoute }}</span>
          <i
            v-if="!isMobile"
            :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            @click="toggleCollapse"
            class="collapse-icon"
          ></i>
          <el-breadcrumb v-if="!isMobile" separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-if="currentRoute">{{ currentRoute }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="header-right">
          <el-button
            type="warning"
            size="small"
            icon="el-icon-star-on"
            :aria-label="isMobile ? '加入会员' : undefined"
            @click="openVipPage"
            class="vip-btn"
          >
            <span v-if="!isMobile" class="header-btn-text">加入会员</span>
          </el-button>
          <!-- 顶栏工单入口已隐藏；路由 /ticket 仍保留，后台客服可继续处理 -->
          <el-badge
            v-if="false"
            :value="ticketOpenCount"
            :hidden="ticketOpenCount === 0"
            class="ticket-badge"
          >
            <el-button type="success" size="small" @click="openTicketPage" class="ticket-btn">
              <i class="el-icon-document"></i>
              工单
            </el-button>
          </el-badge>
          <el-badge :value="unreadMessageCount" :hidden="unreadMessageCount === 0" class="message-badge">
            <el-button
              type="info"
              size="small"
              icon="el-icon-bell"
              :aria-label="isMobile ? '站内信' : undefined"
              @click="openMessagePage"
              class="message-btn"
            >
              <span v-if="!isMobile" class="header-btn-text">站内信</span>
            </el-button>
          </el-badge>
          <el-popover
            v-model="userMenuVisible"
            :placement="isMobile ? 'bottom' : 'bottom-end'"
            trigger="click"
            :width="isMobile ? '100%' : 340"
            popper-class="user-account-popover"
            :visible-arrow="false"
          >
            <user-account-panel
              :user-profile="userProfile"
              :member-expire-text="memberExpireText"
              :member-remain-text="memberRemainText"
              :member-days-left="memberDaysLeft"
              :member-expiring-soon="memberExpiringSoon"
              :member-progress-percent="memberProgressPercent"
              @navigate="navigateFromMenu"
              @upgrade="goMemberUpgradeFromMenu"
              @logout="logoutFromMenu"
            />

            <span
              slot="reference"
              class="header-user-trigger"
              :class="{ 'is-active': userMenuVisible }"
            >
              <el-avatar size="small" icon="el-icon-user-solid" class="header-avatar"></el-avatar>
              <span class="header-user-meta">
                <span class="header-user-name">{{ userProfile.username }}</span>
                <span class="header-user-level" :class="'header-user-level--' + userProfile.member.levelKey">
                  {{ userProfile.member.levelName }}
                </span>
              </span>
              <i class="el-icon-arrow-down header-user-chevron"></i>
            </span>
          </el-popover>
        </div>
      </el-header>
      
      <el-main class="main">
        <router-view></router-view>
      </el-main>
      
      <el-footer class="footer">
        <div class="footer-content">
          <div class="footer-info">
            <p>隶属企业：苏州看飞碟信息科技有限公司</p>
            <p>备案号：苏ICP备2022030041号</p>
          </div>
          <div class="footer-qr">
            <div class="qr-title">公众号</div>
            <div class="qr-image">
              <img src="/web_img/footer/gzh.webp" alt="码智作公众号">
            </div>
          </div>
        </div>
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import {
  getDaysUntilExpire,
  formatExpireDisplay,
  getMemberRemainText,
  isMemberExpiringSoon
} from '@/utils/user-profile'
import UserAccountPanel from '@/components/UserAccountPanel/index.vue'
import { pingOnlineHeartbeat } from '@/api/user'

const ONLINE_HEARTBEAT_MS = 120000

export default {
  name: 'Layout',
  components: { UserAccountPanel },
  data() {
    return {
      isMobile: false,
      mobileMenuOpen: false,
      userMenuVisible: false,
      onlineHeartbeatTimer: null
    }
  },
  computed: {
    ...mapState(['isCollapse']),
    ...mapGetters(['unreadMessageCount', 'ticketOpenCount', 'userProfileView', 'siteConfig']),
    userProfile() {
      return this.userProfileView
    },
    siteLinks() {
      return this.siteConfig || {}
    },
    activeMenu() {
      return this.$route.path
    },
    currentRoute() {
      return this.$route.meta.title || ''
    },
    memberDaysLeft() {
      if (!this.userProfile.member.isVip) return null
      return getDaysUntilExpire(this.userProfile.member.expireDate)
    },
    memberExpireText() {
      if (!this.userProfile.member.isVip) return '—'
      return formatExpireDisplay(this.userProfile.member.expireDate)
    },
    memberRemainText() {
      if (!this.userProfile.member.isVip) return '免费版'
      return getMemberRemainText(this.memberDaysLeft)
    },
    memberExpiringSoon() {
      return isMemberExpiringSoon(this.memberDaysLeft)
    },
    memberProgressPercent() {
      if (!this.userProfile.member.isVip || this.memberDaysLeft === null) return 0
      const totalDays = 365
      return Math.min(100, Math.max(8, Math.round((this.memberDaysLeft / totalDays) * 100)))
    },
    /** 有效会员且非最高可购档，可补差价升级 */
    canUpgradeDiff() {
      const m = this.userProfile && this.userProfile.member
      if (!m || !m.isVip) return false
      const hydj = String(m.hydj != null ? m.hydj : '')
      if (hydj === '3' || hydj === '99') return false
      const key = m.levelKey || ''
      if (key === 'advanced' || key === 'special') return false
      return true
    },
    sidebarWidth() {
      if (this.isMobile) return '280px'
      return this.isCollapse ? '64px' : '200px'
    },
    menuCollapsed() {
      return this.isMobile ? false : this.isCollapse
    }
  },
  watch: {
    '$route'() {
      this.closeMobileMenu()
      this.userMenuVisible = false
    }
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    document.addEventListener('visibilitychange', this.onVisibilityChange)
    if (!this.$store.state.userLoaded) {
      this.$store.dispatch('loadCurrentUser').catch(() => {})
    }
    this.startOnlineHeartbeat()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
    this.stopOnlineHeartbeat()
    document.body.classList.remove('mzz-menu-open')
  },
  methods: {
    startOnlineHeartbeat() {
      this.stopOnlineHeartbeat()
      this.pingOnline()
      this.onlineHeartbeatTimer = setInterval(() => {
        this.pingOnline()
      }, ONLINE_HEARTBEAT_MS)
    },
    stopOnlineHeartbeat() {
      if (this.onlineHeartbeatTimer) {
        clearInterval(this.onlineHeartbeatTimer)
        this.onlineHeartbeatTimer = null
      }
    },
    onVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this.pingOnline()
      }
    },
    pingOnline() {
      if (document.visibilityState === 'hidden') return
      pingOnlineHeartbeat()
        .then((res) => {
          const u = res && res.data && res.data.user
          if (u) {
            this.$store.commit('setUser', u)
          }
        })
        .catch(() => {})
    },
    checkMobile() {
      const wasMobile = this.isMobile
      this.isMobile = window.innerWidth < 768
      if (this.isMobile) {
        this.closeMobileMenu()
      } else if (wasMobile) {
        this.closeMobileMenu()
      }
    },
    onMenuSelect() {
      if (this.isMobile) {
        this.closeMobileMenu()
      }
    },
    toggleCollapse() {
      this.$store.commit('toggleCollapse')
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
      document.body.classList.toggle('mzz-menu-open', this.mobileMenuOpen)
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false
      document.body.classList.remove('mzz-menu-open')
    },
    openVipPage() {
      this.goMemberUpgrade()
    },
    openTicketPage() {
      this.$router.push('/ticket')
    },
    openMessagePage() {
      this.$router.push('/message')
    },
    openUserSettings() {
      this.$router.push('/user/settings')
    },
    goMemberUpgrade() {
      if (this.$route.path === '/member/upgrade') return
      this.$router.push('/member/upgrade')
    },
    goMemberUpgradeFromMenu() {
      this.userMenuVisible = false
      this.goMemberUpgrade()
    },
    navigateFromMenu(path) {
      this.userMenuVisible = false
      if (this.$route.path === path) return
      this.$router.push(path)
    },
    logoutFromMenu() {
      this.userMenuVisible = false
      this.handleLogout()
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$store.dispatch('logout')
        this.$message.success('已退出登录')
        this.$router.replace('/login')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
}

.sidebar {
  background-color: #ffffff;
  border-right: 1px solid #e6e6e6;
  transition: width 0.3s;
  overflow-x: hidden;
  overflow-y: auto;
  height: 100vh;
  flex-shrink: 0;
}

.layout-body {
  flex: 1;
  min-width: 0;
  min-height: 0;
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  color: #409EFF;
  border-bottom: 1px solid #e6e6e6;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}

.logo:hover {
  background-color: #f5f9ff;
  color: #337ecc;
}

.el-menu {
  border-right: none;
}

.el-menu-item, .el-submenu__title {
  height: 50px;
  line-height: 50px;
}

.el-menu-item:hover, .el-submenu__title:hover {
  background-color: #f5f7fa;
}

.el-menu-item.is-active {
  background-color: #ecf5ff;
  border-right: 3px solid #409EFF;
}

.header {
  background-color: #ffffff;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 60px;
  flex-shrink: 0;
}

.header-left {
  display: flex;
  align-items: center;
}

.collapse-icon {
  font-size: 20px;
  cursor: pointer;
  margin-right: 20px;
  color: #333;
}

.collapse-icon:hover {
  color: #409EFF;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 15px;
}

.vip-btn {
  display: flex;
  align-items: center;
  background-color: #13adff !important;
  border-color: #13adff !important;
  white-space: nowrap;
}

.vip-btn:hover {
  background-color: #0d9fe0 !important;
  border-color: #0d9fe0 !important;
}

.vip-btn i {
  margin-right: 5px;
}

.header-btn-text {
  margin-left: 2px;
}

.message-btn {
  position: relative;
  white-space: nowrap;
}

.message-btn i {
  margin-right: 5px;
}

.message-badge {
  margin-right: 10px;
}

.ticket-btn {
  white-space: nowrap;
}

.ticket-btn i {
  margin-right: 5px;
}

.ticket-badge {
  margin-right: 10px;
}

.el-dropdown-link {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #333;
}

.main {
  background-color: #f5f7fa;
  padding: 12px 16px 16px;
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.footer {
  background-color: #ffffff;
  border-top: 1px solid #e6e6e6;
  padding: 10px 20px;
  flex-shrink: 0;
  height: auto !important;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  gap: 16px;
}

.footer-info p {
  margin: 2px 0;
  color: #666;
  font-size: 13px;
  line-height: 1.5;
}

.footer-qr {
  text-align: center;
  flex-shrink: 0;
}

.qr-title {
  margin-bottom: 4px;
  color: #333;
  font-size: 12px;
}

.qr-image img {
  width: 72px;
  height: 72px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  display: block;
}

.mobile-menu-btn {
  display: none;
  font-size: 22px;
  cursor: pointer;
  margin-right: 12px;
  color: #333;
  flex-shrink: 0;
  position: relative;
  z-index: 10;
  padding: 8px;
  margin-left: -4px;
  -webkit-tap-highlight-color: transparent;
}

.mobile-overlay {
  display: none;
}

@media screen and (max-width: 767px) {
  .layout-container {
    height: 100%;
    height: 100dvh;
    max-height: 100dvh;
  }

  .layout-body {
    height: 100%;
    max-height: 100dvh;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-y;
  }

  .main {
    overflow: visible !important;
    flex: none !important;
    min-height: auto !important;
  }

  .header {
    position: sticky;
    top: 0;
    z-index: 100;
    background-color: #ffffff;
  }

  .mobile-menu-btn {
    display: block;
  }

  .sidebar {
    position: fixed !important;
    z-index: 2000;
    top: 0;
    bottom: 0;
    transition: left 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .mobile-overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(15, 23, 42, 0.45);
    z-index: 1999;
  }

  .logo {
    font-size: 18px;
    height: 52px;
  }

  .sidebar-mobile-head + .logo {
    display: none;
  }

  .vip-btn,
  .message-btn {
    flex-shrink: 0;
  }

  /* 顶栏图标按钮 — 勿隐藏 el-button 内层 span（会连同 icon 一起隐藏） */
  .header-right .vip-btn,
  .header-right .message-btn {
    min-width: 40px;
    width: 40px;
    height: 40px;
    padding: 0 !important;
    overflow: visible;
  }

  .header-right .vip-btn [class*="el-icon"],
  .header-right .message-btn [class*="el-icon"] {
    font-size: 18px;
  }

  .header-user-meta {
    display: none;
  }

  .header-user-trigger {
    padding: 4px;
  }

  .header-left {
    min-width: 0;
    flex: 1;
  }
}
</style>
